import React from 'react';
import { motion } from 'framer-motion';
import { FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    name: 'Sarah & Michael T.',
    role: 'Home Buyers',
    text: "Working with Eleanor was an absolute dream. She understood exactly what we were looking for and didn't stop until she found us the perfect home. Her negotiation skills are unmatched.",
    image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?q=80&w=200&auto=format&fit=crop'
  },
  {
    name: 'David R.',
    role: 'Property Investor',
    text: "As an investor, I need an agent who understands numbers and market trends. Eleanor provides detailed analysis and has helped me secure several highly profitable properties.",
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop'
  },
  {
    name: 'The Johnson Family',
    role: 'Home Sellers',
    text: "Eleanor sold our house in less than a week for above asking price. The marketing strategy, professional staging, and photography were top-tier. Highly recommend!",
    image: 'https://images.unsplash.com/photo-1544717302-de2939b7ef71?q=80&w=200&auto=format&fit=crop'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute w-full h-full">
          <polygon points="0,100 100,0 100,100" fill="currentColor" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold text-amber-500 uppercase tracking-widest mb-2">Client Reviews</h2>
          <h3 className="text-3xl md:text-4xl font-bold font-serif mb-4">What Our Clients Say</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 relative"
            >
              <div className="flex text-amber-500 mb-6">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="fill-current text-sm mr-1" />
                ))}
              </div>
              <p className="text-slate-300 mb-8 italic leading-relaxed">"{testimonial.text}"</p>
              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-slate-600"
                />
                <div>
                  <div className="font-bold text-white">{testimonial.name}</div>
                  <div className="text-xs text-amber-500 uppercase tracking-wider">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;